import { useEffect, useState } from "react";
import { Clock3 } from "lucide-react";
import { WeeklyHoursTable } from "@/components/connecteam/WeeklyHoursPanel";
import { api, formatApiError } from "@/lib/api";

export function AssignmentHoursPanel({ assignmentId }) {
  const [data, setData] = useState(null);
  const [error, setError] = useState("");

  useEffect(() => {
    let cancelled = false;
    setData(null);
    setError("");
    api
      .get(`/connecteam/assignments/${assignmentId}/weekly-hours`)
      .then((response) => !cancelled && setData(response.data))
      .catch((requestError) => !cancelled && setError(requestError?.response?.status === 403 ? "" : formatApiError(requestError)));
    return () => {
      cancelled = true;
    };
  }, [assignmentId]);

  if (error) return <p className="form-message error-message" data-testid="assignment-hours-error">{error}</p>;
  if (!data) return null;
  const rows = data.client_id ? data.at_client : data.rows;
  const elsewhere = data.client_id ? data.rows.filter((row) => row.client_id !== data.client_id) : [];
  return (
    <section className="assignment-hours-panel" data-testid="assignment-hours-panel">
      <div className="section-heading">
        <div>
          <h3><Clock3 size={17} /> Hours worked (Connecteam)</h3>
          <p>Weekly hours this provider clocked at this client, from the nightly read-only sync. HR / System Administrator only.</p>
        </div>
      </div>
      {!data.available ? <p className="pairing-meta" data-testid="assignment-hours-unavailable">{data.reason}</p> : <WeeklyHoursTable weeks={data.weeks} rows={rows} testId="assignment-hours-table" emptyText="No completed time entries at this client in the last six weeks." />}
      {data.available && elsewhere.length > 0 && (
        <details className="supervision-history" data-testid="assignment-hours-elsewhere">
          <summary>{elsewhere.length} other site(s) this provider clocked at in the window</summary>
          <WeeklyHoursTable weeks={data.weeks} rows={elsewhere} testId="assignment-hours-elsewhere-table" emptyText="" />
        </details>
      )}
    </section>
  );
}
